import loginBackground from '@treneo/assets/images/login-background.jpeg';
import { Spacing } from '@treneo/shared/themes';

import { Box } from '../components/box';
import { Card } from '../components/card';
import { Typography } from '../components/typography';
import { styled } from '../styled';

export const MainGrid = styled(Box)`
  background-image: url(${loginBackground});
  min-height: 100svh;
  display: flex;
  align-content: center;
  align-items: center;
`;

export const InnerGrid = styled(Box)`
  padding: ${Spacing.large};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const AuthStyledCard = styled(Card)`
  flex: 1;
  max-width: 525px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
  padding: ${Spacing.large};
`;

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: ${Spacing.large};
`;

export const StyledBannerTittle = styled(Typography)`
  max-width: 300px;
  text-align: center;
`;

export const SideBanner = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const Banner = styled('img')`
  max-width: 415px;
`;

export const BottomContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
`;
